export default __webpack_public_path__ + "static/media/figma.92892fc0.svg";